import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "upload-wrapper" }
const _hoisted_2 = { class: "form-group form-inline d-flex mt-2 mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "me-2 mt-1" }, "Admission Period:", -1 /* HOISTED */)
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientDocuments = _resolveComponent("PatientDocuments")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "fas fa-times align-self-end close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
    }),
    _createVNode(_component_PatientDocuments, {
      ref: "patientDocuments",
      title: _ctx.options.title,
      "patient-id": _ctx.options.patientId,
      "upload-document": _ctx.uploadDocument,
      "delete-document": _ctx.deleteDocument,
      "get-documents": _ctx.getPatientDocuments,
      "is-edit-patient": !!_ctx.options.isEditPatient,
      providerId: _ctx.options.providerId,
      application: _ctx.options.application,
      accountId: _ctx.options.accountId
    }, {
      "document-filters": _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("select", {
              name: "admission-period",
              class: "form-select w-10",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedPatientVersionId) = $event))
            }, [
              _createElementVNode("option", { value: _ctx.emptyGuid }, "All", 8 /* PROPS */, _hoisted_4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admissionPeriods, (admissionPeriod) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: admissionPeriod.patientVersionId
                }, _toDisplayString(_ctx.getAdmissionPeriodLabel(admissionPeriod)), 9 /* TEXT, PROPS */, _hoisted_5))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.selectedPatientVersionId]
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "patient-id", "upload-document", "delete-document", "get-documents", "is-edit-patient", "providerId", "application", "accountId"])
  ]))
}